﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconCalendarStats } from "@tabler/icons-react";
import { PlantillasHorariosDef } from "./PlantillasHorariosDef";

export const PlantillasHorariosIcon = IconCalendarStats;
export const PlantillasHorariosHelpText = "* Aquí tendra la lista de todas las zonas horarias disponibles.";

export class PlantillasHorarios extends Entity<PlantillasHorariosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PlantillasHorariosDef(), parentKeys);
        super.Form = import('./PlantillasHorariosForm').then((module) => module.PlantillasHorariosForm);
        this.Title = "Plantillas de Horario";
        this.Icon = PlantillasHorariosIcon;
        this.HelpText = PlantillasHorariosHelpText;
    }
}